<script lang="ts">
  import { cn } from '@/lib/utils';
  import { changeTone, formatChange, formatNumber, perWeek, type DetailRow } from './statFormat';

  export let rows: DetailRow[];
  export let rangeDays: number;
  /** The card's own column layout, so each value sits directly under its heading in the row above. */
  export let columns: string;
  export let decimals: number = 1;
</script>

<!-- One block per measure: its name, then Start / End / Change / per week in the same columns as the card's main row. -->
<div class="flex flex-col gap-2">
  {#each rows as row}
    {@const change = row.end - row.start}
    {@const tone = changeTone(change, decimals)}
    <div>
      <div class="text-[11px] text-muted-foreground leading-tight">{row.label}</div>
      <div class="grid gap-x-2 text-[13px] tabular-nums whitespace-nowrap" style="grid-template-columns: {columns}">
        <span>{formatNumber(row.start, decimals)}</span>
        <span>{formatNumber(row.end, decimals)}</span>
        <span class={cn(tone === 'up' && 'text-green-600', tone === 'down' && 'text-red-600')}>{formatChange(change, decimals)}</span>
        <span>{formatChange(perWeek(change, rangeDays), decimals)}</span>
      </div>
    </div>
  {/each}
</div>
